import React, { HTMLAttributes } from 'react'
import Input from '@components/Input'

export interface IInputNumber extends Omit<HTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange?: (value: number) => void
  value?: number
  min?: number
  max?: number
}

const InputNumber: React.FC<IInputNumber> = (props) => {
  const { onChange, min, max, ...inputProps } = props
  const changeHandler = onChange
    ? (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value
        if (value === '') {
          onChange(min ? min : 0)
          return
        }
        const numberValue = parseInt(value)
        if (!isNaN(numberValue)) {
          if (min && numberValue < min) {
            onChange(min)
            return
          }
          if (max && numberValue > max) {
            onChange(max)
            return
          }
          onChange(numberValue)
          return
        }
      }
    : undefined

  return <Input {...inputProps} onChange={changeHandler} />
}

export default InputNumber
